export const animation = () => {
	const chatMessages    = document.querySelectorAll('.chat-message') as NodeListOf<HTMLElement>;
	const typingIndicator = document.querySelector('.typing-indicator') as HTMLElement;
	let isAnimating       = false;
	if (chatMessages.length === 0 || !typingIndicator) {
		return;
	}

	function animateChat() {
		if (isAnimating) {
			return;
		}
		isAnimating = true;
		chatMessages.forEach(message => {
			message.style.opacity   = '0';
			message.style.transform = 'translateY(20px)';
		});
		typingIndicator.style.opacity   = '0';
		typingIndicator.style.transform = 'translateY(20px)';
		setTimeout(() => {
			chatMessages[0].style.transition = 'all 0.5s ease-out';
			chatMessages[0].style.opacity    = '1';
			chatMessages[0].style.transform  = 'translateY(0)';
		}, 500);
		setTimeout(() => {
			typingIndicator.style.transition = 'all 0.3s ease-out';
			typingIndicator.style.opacity    = '1';
			typingIndicator.style.transform  = 'translateY(0)';
		}, 1500);
		setTimeout(() => {
			typingIndicator.style.opacity   = '0';
			typingIndicator.style.transform = 'translateY(20px)';
		}, 3000);
		setTimeout(() => {
			chatMessages[1].style.transition = 'all 0.5s ease-out';
			chatMessages[1].style.opacity    = '1';
			chatMessages[1].style.transform  = 'translateY(0)';
		}, 3500);
		setTimeout(() => {
			chatMessages[2].style.transition = 'all 0.5s ease-out';
			chatMessages[2].style.opacity    = '1';
			chatMessages[2].style.transform  = 'translateY(0)';
		}, 5500);
		setTimeout(() => {
			typingIndicator.style.opacity   = '1';
			typingIndicator.style.transform = 'translateY(0)';
		}, 7000);
		setTimeout(() => {
			typingIndicator.style.opacity   = '0';
			typingIndicator.style.transform = 'translateY(20px)';
		}, 9000);
		setTimeout(() => {
			chatMessages[3].style.transition = 'all 0.5s ease-out';
			chatMessages[3].style.opacity    = '1';
			chatMessages[3].style.transform  = 'translateY(0)';
		}, 9500);
		setTimeout(() => {
			isAnimating = false;
		}, 11000);
	}

	const observer    = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				animateChat();
			}
		});
	}, {threshold: 0.5});
	const chatSection = document.querySelector('.space-y-4');
	if (chatSection && chatSection.parentElement) {
		observer.observe(chatSection.parentElement);
	}
}
